import { render } from "./Dashboard_PCP.vue?vue&type=template&id=1876e6f2&ts=true"
import script from "./Dashboard_PCP.vue?vue&type=script&lang=ts"
export * from "./Dashboard_PCP.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__